if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        // Bottom-center control cluster: prev / close / next.
        this.nav = this.querySelector('.product-media-modal__nav');
        if (this.nav) {
          // Keep interactions with the controls from bubbling up to the
          // media-modal's "pointerup anywhere closes" handler (mouse/desktop).
          this.nav.addEventListener('pointerup', (event) => event.stopPropagation());

          const prev = this.nav.querySelector('.product-media-modal__nav-btn--prev');
          const next = this.nav.querySelector('.product-media-modal__nav-btn--next');
          if (prev)
            prev.addEventListener('click', (event) => {
              event.preventDefault();
              this.navigate(-1);
            });
          if (next)
            next.addEventListener('click', (event) => {
              event.preventDefault();
              this.navigate(1);
            });
        }

        // Arrow-key navigation while the lightbox is open.
        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowRight') this.navigate(1);
          if (event.code === 'ArrowLeft') this.navigate(-1);
        });
      }

      hide() {
        super.hide();
      }

      navigate(direction) {
        const items = Array.from(this.querySelectorAll('[data-media-id]'));
        if (items.length < 2) return;

        let currentIndex = items.findIndex((element) => element.classList.contains('active'));
        if (currentIndex === -1) currentIndex = 0;
        const nextIndex = (currentIndex + direction + items.length) % items.length;

        const target = items[nextIndex];
        items[currentIndex].classList.remove('active');
        target.classList.add('active');

        const container = this.querySelector('[role="document"]');
        if (!container) return;

        // Wait one frame so visibility/layout settles (on mobile, inactive
        // media are display:none), then align the new media to the top of the
        // viewport and centre it horizontally.
        requestAnimationFrame(() => {
          const delta = target.getBoundingClientRect().top - container.getBoundingClientRect().top;
          container.scrollTo({ top: container.scrollTop + delta, behavior: 'smooth' });
          if (target.width) {
            container.scrollLeft = (target.width - container.clientWidth) / 2;
          }
        });
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
